import './index.scss'
import React, {useEffect, useRef, useState} from "react";
import { Toast } from "antd-mobile";
import {Header} from "../../../../components";
import Service from "../service";
import Library from "../../../../library";
import Services from "services";
import { useHistory, useParams,useLocation} from 'react-router-dom';

const { JsBridge, Platform } = Library;
const isMiniprogram = Platform.check.isMiniprogram()

let SwiperNc = null;

const Login = () => {
  const pageDom = useRef(null);
  const countdownTimer = useRef(null);
  const timeLimitTimer = useRef(null);
  const {clientId, openId} = Library.Util.url.paramsToObj();
  const [data, setData] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [countdown, setCountdown] = useState(0);
  const [timeLeft, setTimeLeft] = useState({ days: 4, hours: 0, minutes: 0, seconds: 0 });
  const [isSuccess, setIsSuccess] = useState(false);
  const [isJustReceived, setIsJustReceived] = useState(false); // 是否刚刚领取成功
  const [isRealNameVerified, setIsRealNameVerified] = useState(false);
  const [isExpired, setIsExpired] = useState(false); // 是否已失效
  const [collectionImage, setCollectionImage] = useState(''); // 藏品图片
  const [isNcLoaded, setIsNcLoaded] = useState(false); // 滑动验证码是否加载完成
  const [shareStatusResult, setShareStatusResult] = useState(null); // 领取接口返回的分享状态：ALREADY_CLAIMED | OWN_COLLECTION
  const [remainingClaimTimeStr, setRemainingClaimTimeStr] = useState(''); // 剩余领取时间（接口返回）

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const shareRecordId = params.get('shareRecordId');
  const expireTime = params.get('expireTime');
  const imageBg = params.get('imageBg');

  useEffect(() => {
    getData();
    initNC();
    
    // expireTime 与当前时间相比，差值赋给 totalSeconds（单位：秒）
    // 支持 ISO 格式(2026-02-02T17:54:38.292) 或时间戳
    let totalSeconds = 4 * 24 * 60 * 60; // 默认 4 天
    if (expireTime) {
      let expireMs;
      if (typeof expireTime === 'string' && (expireTime.includes('T') || expireTime.includes('-'))) {
        expireMs = new Date(expireTime).getTime();
      } else {
        const num = Number(expireTime);
        expireMs = (num < 10000000000 ? num * 1000 : num);
      }
      if (!isNaN(expireMs)) {
        const diffMs = expireMs - Date.now();
        totalSeconds = Math.max(0, Math.floor(diffMs / 1000));
      }
    }
    
    const updateTimeLeft = () => {
      if (totalSeconds <= 0) {
        if (timeLimitTimer.current) {
          clearInterval(timeLimitTimer.current);
          timeLimitTimer.current = null;
        }
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      
      const days = Math.floor(totalSeconds / (24 * 60 * 60));
      const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60));
      const minutes = Math.floor((totalSeconds % (60 * 60)) / 60);
      const seconds = totalSeconds % 60;
      
      setTimeLeft({ days, hours, minutes, seconds });
      totalSeconds -= 1;
    };
    
    // 立即更新一次
    updateTimeLeft();
    
    // 启动倒计时
    timeLimitTimer.current = setInterval(updateTimeLeft, 1000);
    
    // 组件卸载时清理定时器
    return () => {
      if (countdownTimer.current) {
        clearInterval(countdownTimer.current);
      }
      if (timeLimitTimer.current) {
        clearInterval(timeLimitTimer.current);
      }
    };
  }, []);

  // 监听倒计时结束，如果未领取则标记为已失效
  useEffect(() => {
    const isTimeUp = timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0;
    if (isTimeUp && !isSuccess) {
      setIsExpired(true);
    }
  }, [timeLeft, isSuccess]);

  // 初始化滑动验证码
  const initNC = async () => {
    try {
      const module = await import('components/txCaptcha');
      SwiperNc = module.TxCaptcha;
      setIsNcLoaded(true);
    } catch (error) {
      console.log('加载验证码组件失败:', error);
    }
  };

  const getData = async () => {
    try {
      const userInfoRes = await JsBridge.getCurrentUserInfo();
      setUserInfo(userInfoRes);
      // const result = await Service.getInitData(
      //   {
      //     clientId: isMiniprogram ? clientId : userInfoRes?.clientId,
      //     miniOpenId: isMiniprogram && openId && openId !== 'undefined' && openId !== 'null' ? openId : null,
      //   },
      //   false,
      // );
      // if (result?.data) {
      //   setData(result.data);
      //   // 检查是否已经领取过
      //   if (result.data.isReceived) {
      //     setIsSuccess(true);
      //     setIsJustReceived(false); // 已领取状态，不是刚刚领取
      //     setIsRealNameVerified(result.data.isRealNameVerified || false);
      //     setCollectionImage(result.data.collectionImage || '');
      //   }
      // } else {
        // 假数据
        const mockData = {
          list: [
            { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 52, label: 'VIP尊享', style: { position: 'absolute', bottom: '10%', left: '5%' } },
            { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 9, label: '尊享', style: { position: 'absolute', bottom: '30%', left: '25%' } },
            { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: 11, label: '兑换礼品', style: { position: 'absolute', bottom: '30%', right: '25%' } },
            { imgUrl: 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png', count: '100+', label: '门店', style: { position: 'absolute', bottom: '10%', right: '5%' } },
          ],
        };
        setData(mockData);
        
        // 检查URL参数或localStorage中是否已领取
        // const hasReceived = localStorage.getItem('hasReceived') === 'true';
        // if (hasReceived) {
        //   setIsSuccess(true);
        //   setIsJustReceived(false); // 已领取状态，不是刚刚领取
        // }
      // }
    } catch (error) {
      console.log('获取数据失败:', error);
    }
  };

  const handleGetCode = async () => {
    // 验证手机号
    if (!phone) {
      Toast.show('请输入手机号');
      return;
    }
    
    if (!Library.Util.validate.mobile(phone)) {
      Toast.show('请输入正确的手机号');
      return;
    }
    
    // 如果正在倒计时，不允许重复发送
    if (countdown > 0) {
      return;
    }
    
    // 检查验证码组件是否加载完成
    if (!isNcLoaded) {
      Toast.show('验证码组件加载中，请稍候');
      return;
    }
    
    try {
      // 调用滑动验证码
      const res = await SwiperNc();
      if (!res) {
        return; // 用户取消验证
      }
      
      // 调用发送验证码接口，传入验证码返回的数据（包含ticket）
      const result = await Services('DynamicCode', 'GetDynamicCode', {
        mobile: phone,
        ...res
      });
      
      if (result && result.status > 0) {
        // 发送成功，启动倒计时
        // 清除之前的定时器
        if (countdownTimer.current) {
          clearInterval(countdownTimer.current);
          countdownTimer.current = null;
        }
        
        // 设置初始倒计时
        let currentCount = 60;
        setCountdown(currentCount);
        
        // 启动倒计时
        countdownTimer.current = setInterval(() => {
          currentCount -= 1;
          setCountdown(currentCount);
          
          if (currentCount <= 0) {
            if (countdownTimer.current) {
              clearInterval(countdownTimer.current);
              countdownTimer.current = null;
            }
            setCountdown(0);
          }
        }, 1000);
      } else {
        Toast.show(result?.data?.msg || '发送验证码失败，请重试');
      }
    } catch (error) {
      console.log('发送验证码失败:', error);
      Toast.show('发送验证码失败，请重试');
    }
  };

  const handleConfirm = async () => {
    if (!phone || !code) {
      Toast.show('请填写完整信息');
      return;
    }

    try {
      const params = {
        mobile: phone,
        dynamicCode: code,
        shareRecordId,
      };
      console.log('params3333====>', params);
      const result = await Service.loginForClaimShare(params);
      console.log('params44444====>', result);
      const resData = result?.data || result;

      if (!resData) {
        Toast.show({ content: '领取失败，请重试' });
        return;
      }

      const { shareStatus, realName, remainingClaimTime } = resData;
      setShareStatusResult(null);

      switch (shareStatus) {
        case 'CLAIMED_SUCCESS':
          setIsSuccess(true);
          setIsJustReceived(true);
          setIsRealNameVerified(!!realName);
          setRemainingClaimTimeStr(remainingClaimTime ?? '');
          setCollectionImage(resData.imageBg || imageBg || resData.collectionImage || 'https://gu-nft-test1.obs.cn-east-3.myhuaweicloud.com/collection/General/carbon1t.png');
          break;
        case 'ALREADY_CLAIMED':
          setShareStatusResult('ALREADY_CLAIMED');
          Toast.show({ content: '已被领取' });
          break;
        case 'EXPIRED':
          setIsExpired(true);
          Toast.show({ content: '已失效' });
          break;
        case 'OWN_COLLECTION':
          setShareStatusResult('OWN_COLLECTION');
          Toast.show({ content: '这是您自己的藏品' });
          break;
        default:
          Toast.show({ content: shareStatus ? `领取异常：${shareStatus}` : '领取失败，请重试' });
      }
    } catch (error) {
      console.log('领取失败:', error);
      Toast.show({ content: '领取失败，请重试' });
    }
  };

  const handleOpenApp = () => {
    // 打开G优链接
    window.location.href = 'https://app.gkewang.com/index';
  };

  // 藏品列表
  const collectionList = data?.list || [];

  return (
    <div className="Login" ref={pageDom}>
      <div className="login-container">
        {shareStatusResult === 'ALREADY_CLAIMED' ? (
          /* 已被领取 - 专用展示 */
          <div className="success-section">
            <div className="time-limit-box">
              <span className="time-label">限时领取:</span>
              <span className="time-count">
                还剩{timeLeft.days}天{timeLeft.hours}小时{timeLeft.minutes}分{timeLeft.seconds}秒
              </span>
            </div>
            <div className="expired-status">
              <div className="expired-text">已被领取</div>
            </div>
            <button className="open-app-btn" onClick={handleOpenApp}>
              下载/打开G优查看
            </button>
          </div>
        ) : shareStatusResult === 'OWN_COLLECTION' ? (
          /* 这是您自己的藏品 - 专用展示 */
          <div className="success-section">
            <div className="time-limit-box">
              <span className="time-label">限时领取:</span>
              <span className="time-count">
                还剩{timeLeft.days}天{timeLeft.hours}小时{timeLeft.minutes}分{timeLeft.seconds}秒
              </span>
            </div>
            <div className="expired-status">
              <div className="expired-text">这是您自己的藏品</div>
            </div>
            <button className="open-app-btn" onClick={handleOpenApp}>
              下载/打开G优查看
            </button>
          </div>
        ) : isExpired ? (
          /* 已失效状态页面 */
          <div className="success-section">
            {/* 限时领取 */}
            <div className="time-limit-box">
              <span className="time-label">限时领取:</span>
              <span className="time-count">
                还剩{timeLeft.days}天{timeLeft.hours}小时{timeLeft.minutes}分{timeLeft.seconds}秒
              </span>
            </div>

            {/* 已失效状态 */}
            <div className="expired-status">
              <div className="expired-text">已失效</div>
            </div>

            {/* 打开链接按钮 */}
            <button className="open-app-btn" onClick={handleOpenApp}>
              下载/打开G优查看
            </button>
          </div>
        ) : !isSuccess ? (
          /* 表单区域 */
          <div className="form-section">
            {/* 限时领取 */}
            <div className="time-limit-box">
              <span className="time-label">限时领取:</span>
              <span className="time-count">
                还剩{timeLeft.days}天{timeLeft.hours}小时{timeLeft.minutes}分{timeLeft.seconds}秒
              </span>
            </div>

            {/* 输入框区域 */}
            <div className="input-group">
              <label className="input-label">手机号:</label>
              <input
                type="tel"
                className="input-field"
                placeholder="请输入手机号"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            <div className="input-group">
              <label className="input-label">验证码:</label>
              <div className="code-input-wrapper">
                <input
                  type="text"
                  className="input-field code-input"
                  placeholder="请输入验证码"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                />
                <button
                  className={`get-code-btn ${countdown > 0 ? 'countdown' : ''}`}
                  onClick={handleGetCode}
                  disabled={countdown > 0}
                >
                  {countdown > 0 ? `${countdown}s` : '获取验证码'}
                </button>
              </div>
            </div>

            {/* 确认领取按钮 */}
            <button className="confirm-btn" onClick={handleConfirm}>
              确认领取
            </button>
          </div>
        ) : (
          /* 已领取状态页面 */
          <div className="success-section">
            {/* 限时领取 */}
            <div className="time-limit-box">
              <span className="time-label">限时领取:</span>
              <span className="time-count">
                还剩{timeLeft.days}天{timeLeft.hours}小时{timeLeft.minutes}分{timeLeft.seconds}秒
              </span>
            </div>

            {/* 如果倒计时结束且已领取，显示藏品图片 */}
            {/* {remainingClaimTimeStr && (
              <div className="time-limit-box" style={{ marginBottom: 8 }}>
                <span className="time-label">剩余领取时间:</span>
                <span className="time-count">{remainingClaimTimeStr}</span>
              </div>
            )} */}
            {timeLeft.days === 0 && timeLeft.hours === 0 && timeLeft.minutes === 0 && timeLeft.seconds === 0 ? (
              <div className="collection-display-box">
                {collectionImage ? (
                  <img src={collectionImage} alt="藏品" className="collection-image" />
                ) : (
                  <div className="collection-placeholder">这是您自己的藏品</div>
                )}
              </div>
            ) : isJustReceived ? (
              /* 领取成功消息框 */
              <div className="success-box">
                <div className="success-title">恭喜你! 领取成功!</div>
                {!isRealNameVerified && (
                  <div className="realname-notice">
                    <div className="notice-text">当前未实名, 请前往G优实名</div>
                    <div className="notice-text">超过90天未实名则视为放弃藏品</div>
                  </div>
                )}
              </div>
            ) : (
              /* 已领取状态 */
              <div className="received-status">
                <div className="received-text">已被领取</div>
              </div>
            )}

            {/* 打开链接按钮 */}
            <button className="open-app-btn" onClick={handleOpenApp}>
              下载/打开G优查看
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
export default Login